import { Link } from 'react-router-dom';

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="footer-top-row">
        <button
          type="button"
          className="back-to-top"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        >
          ↑ Back to Top
        </button>
      </div>

      <div className="footer-main">
        <div className="footer-brand-col">
          <p className="footer-brand-title">Powered by Polyrion Blockchain</p>
          <p className="footer-brand-text">
            Polyrionscan is the leading block explorer and Search API & Analytics platform for
            the Polyrion blockchain.
          </p>
        </div>

        <div className="footer-links-col">
          <h4>Company</h4>
          <Link to="/about">About Us</Link>
          <Link to="/branding">Branding</Link>
          <Link to="/contact">Contact Us</Link>
          <Link to="/terms">Terms of Service</Link>
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/bug-bounty">Bug Bounty</Link>
        </div>

        <div className="footer-links-col">
          <h4>Community</h4>
          <a href="/">API Docs</a>
          <a href="/">Polyrion Docs</a>
          <a href="/">Knowledge Base</a>
        </div>

        <div className="footer-links-col">
          <h4>Products & Services</h4>
          <a href="/">Advertise</a>
          <a href="/">Explorer as a Service (FaaS)</a>
          <a href="/">API Plans</a>
          <a href="/">Priority Support</a>
          <a href="/">Token Update</a>
        </div>
      </div>

      <div className="footer-bottom">
        <p>Polyrionscan @{year}</p>
      </div>
    </footer>
  );
}

export default Footer;
